/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AchParticipant,
  AchParticipant$inboundSchema,
  AchParticipant$Outbound,
  AchParticipant$outboundSchema,
} from "./achparticipant.js";

export type FinancialInstitutions = {
  achParticipants: Array<AchParticipant>;
};

/** @internal */
export const FinancialInstitutions$inboundSchema: z.ZodType<
  FinancialInstitutions,
  z.ZodTypeDef,
  unknown
> = z.object({
  achParticipants: z.array(AchParticipant$inboundSchema),
});
/** @internal */
export type FinancialInstitutions$Outbound = {
  achParticipants: Array<AchParticipant$Outbound>;
};

/** @internal */
export const FinancialInstitutions$outboundSchema: z.ZodType<
  FinancialInstitutions$Outbound,
  z.ZodTypeDef,
  FinancialInstitutions
> = z.object({
  achParticipants: z.array(AchParticipant$outboundSchema),
});

export function financialInstitutionsToJSON(
  financialInstitutions: FinancialInstitutions,
): string {
  return JSON.stringify(
    FinancialInstitutions$outboundSchema.parse(financialInstitutions),
  );
}
export function financialInstitutionsFromJSON(
  jsonString: string,
): SafeParseResult<FinancialInstitutions, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => FinancialInstitutions$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'FinancialInstitutions' from JSON`,
  );
}
